import { Pagination } from "@mui/material";
import { ChangeEvent, FC, useContext, useRef } from "react";
import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";

import { GridContext } from "../generic/table/grid-context";
import { usePagingStickyEmulation } from "./hooks";

const GridPagingContainerFakeStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "grid-paging-container-fake",
})`
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
  min-height: 28px; // mui paginations buttons height
`;

const GridPagingContainerStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "grid-paging-container",
})`
  margin-top: 10px;
  margin-bottom: 10px;
  margin-inline-end: 20px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: absolute;
  inset-inline-end: 0;
  bottom: 15px;
  will-change: transform;
`;

export const GridPaging: FC = () => {
  const pagingRef = useRef<HTMLDivElement>(null);
  const { setPageIndex, pageCount, pageIndex } = useContext(GridContext);

  const handlePagerChange = (e: ChangeEvent<unknown>, value: number): void => {
    setPageIndex(value - 1);
  };

  usePagingStickyEmulation({ pagingRef });
  const currentPage = pageIndex + 1;

  if (!pageCount) {
    return null;
  }

  return (
    <>
      <GridPagingContainerFakeStyled />
      <GridPagingContainerStyled ref={pagingRef}>
        <Pagination
          size="small"
          page={currentPage}
          count={pageCount}
          onChange={handlePagerChange}
        />
      </GridPagingContainerStyled>
    </>
  );
};
